/**
 * Tiny class-name helper. We use this everywhere a component conditionally
 * composes Tailwind classes. Pulling in clsx keeps the logic simple and
 * `cn()` reads as the standard convention.
 */
import clsx, { type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]): string {
	return clsx(inputs);
}
